import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Page.css';
import PhoneFrame from './PhoneFrame/PhoneFrame';
import SortableLists from './SortableLists/SortableLists';
import MainLayoutContainer from '../MainLayoutContainer/MainLayoutContainer';
import ElementSelector from './ElementSelector/ElementSelector';
import NoElementsMessage from '../../components/NoElementsMessage/NoElementsMessage';

//TODO: this starts to become a "god class" and needs refactoring
class Page extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeButtonType: null,
            recNameCurrent: "new-product",
            recTypeCurrent: props.recTypeCurrent || 2,
            promotionalBannerNameCurrent: "promotion",
            promotionalBannerTypeCurrent: props.promotionalBannerTypeCurrent || 1,
        };
        if(!Array.isArray(this.props.elementTypes)){
            throw new TypeError(`Site ${this.props.pageType} has no defined element types, check assets/elements.json`)
        }
    }

    countAddedGlobalElements = () => {
        let counter = 0;
        if (this.props.header.length > 0) {
            counter++;
        }
        if (this.props.footer.length > 0) {
            counter++;
        }

        return counter;
    }

    requiredTypeHasBeenAdded = (type) => {
        for (const bodyProp of this.props.body) {
            if (bodyProp.type === type) {
                return true;
            }
        }
        return false;
    }

    countAddedTypes = (expectedTypes) => {
        let counter = this.countAddedGlobalElements();
        expectedTypes.forEach(type => {
            if (this.requiredTypeHasBeenAdded(type)) {
                counter++;
            }
        });
        return counter;
    }
    setDataForRecommended = (newObject, originalObject, type) => {
        if (type !== 'newsSection') { return; }
        const config = JSON.parse(originalObject.config);
        config.Type = this.state.recTypeCurrent;
        newObject.config = JSON.stringify(config);
        newObject.name = `${this.props.pageType}-rec`;
    }

    setDataForPromotionalBanner = (newObject, originalObject, type) => {
        if (type !== 'promotionalBanner') { return; }
        const config = JSON.parse(originalObject.config);
        config.Type = this.state.promotionalBannerTypeCurrent;
        newObject.config = JSON.stringify(config);
        newObject.name = `pb-${this.props.pageType}`;
    }

    prepareData = (type) => {
        const data = require(`./../../assets/elements/${type}.js`).default;
        if (!data) {
            return null;
        }
        
        return data.map((d) => {
            const globalElements = require('../../assets/elements.json').globalTypes;
            const withTypesObject = {};
            globalElements.forEach(element => {
                if (d[element] && Object.keys(d[element]).length > 0) {
                    withTypesObject[element] = {
                        ...d[element],
                        type: d[element].id.slice(0, d[element].id.lastIndexOf('-'))
                    }
                }
            });
            const newObject = {
                ...d,
                type: type,
                ...withTypesObject
            };
            this.setDataForRecommended(newObject, d, type);
            this.setDataForPromotionalBanner(newObject, d, type);
            this.setDataForWidget(newObject, d, type);
            return newObject;
        });
    };

    closeElements = () => {
        this.setState({ activeButtonType: null });
        this.props.onElemTypeChange(null);
    }

    handleButtonTypeClick = (newType) => {
        if (newType && newType === this.state.activeButtonType) {
            this.closeElements();
        } else {

            const hightlightedElements = require('../../assets/highlightedElements.json').highlightedElements;
            let isHighlighted = false;
    
            hightlightedElements.forEach(function(item) {
                if (item === newType) {
                    isHighlighted = true;
                }
            });

            if (isHighlighted == true) {
                this.props.currentOpenedNewElements.forEach(function(item) {
                    if (item === newType) {
                        isHighlighted = false;
                    }
                });
            }

            this.setState({ activeButtonType: newType });
            this.props.onElemTypeChange(newType, isHighlighted);

            if (isHighlighted == true) {
                this.props.showNewElementModal(newType);
            }
        }
    }

    handleRecTypeChange = (selected) => {
        this.setState({
            recTypeCurrent: selected.value,
            recNameCurrent: selected.name
        });
        this.props.onRecTypeChange(selected.value, this.props.bodyListName);
        this.props.sidebarRef.current.forceUpdate();
        this.props.navbarRef.current.forceUpdate();
        
        const arrows = document.querySelectorAll('.sidebar .svgArrowRecommend');
        for (const arrow of arrows) {
            arrow.classList.toggle('hidden');
        }
    }

    handlePromotionalBannerTypeChange = (selected) => {
        this.setState({
            promotionalBannerTypeCurrent: selected.value,
            promotionalBannerNameCurrent: selected.name
        });

        this.props.onPromotionalBannerTypeChange(selected.value);
        this.props.sidebarRef.current.forceUpdate();
        this.props.navbarRef.current.forceUpdate();

        const arrows = document.querySelectorAll('.sidebar .svgArrowRecommend');
        for (const arrow of arrows) {
            arrow.classList.toggle('hidden');
        }
    }

    getSortableLists = () => {
        const Lists = <SortableLists
            handleOptionsOpen={this.props.handleOptionsOpen}
            counter={0}
            {...this.props}
            isPreviewOn={this.props.isPreviewOn}
            isMobileOn={this.props.isMobileOn}
        />;
        //when mobile preview is on, wrap the lists with phone frame
        if (this.props.isMobileOn) {
            return <PhoneFrame>{Lists}</PhoneFrame>;
        }
        return Lists;
    };

    getElementsView = () => {
        if (!(this.props.isPreviewOn || this.props.isStyleMenuOpen) || this.countAddedTypes(this.props.elementTypes) > 0) {
            return this.getSortableLists();
        }
        return <NoElementsMessage />;
    }

    getSidebarTemplateMenu = () => (
        <React.Fragment>
            <ElementSelector
                prepareData={this.prepareData}
                handleDragChange={this.props.handleDragStart}
                attachStyleToSvg={this.attachStyleToSvg}
                currentType={this.state.activeButtonType}
                recommendedTypeChangeHandler={this.handleRecTypeChange}
                recommendedTypeCurrent={this.state.recTypeCurrent}
                onTypeSelect={this.handleButtonTypeClick}
                showFixedElements={this.state.showFixedElements}
                handleToggleShowFixedElements={this.toggleShowFixedElements}
                showSwitchButton={this.props.showSwitchButton}
                isMobileOn={this.props.isMobileOn}
                promotionalBannerTypeChangeHandler={this.handlePromotionalBannerTypeChange}
                promotionalBannerTypeCurrent={this.props.promotionalBannerTypeCurrent}
                {...this.props}
            />
        </React.Fragment>
    )
    //LIFECYCLE METHODS
    //on mount, bind elements to sidebar
    componentDidMount = () => { 
        this.props.sidebarRef.current.changeSidebarTemplateMenu(this.getSidebarTemplateMenu);
        this.detectPopup(this.getElementsView());
    };

    //when unmounting page (i.e. when clicking next/previous page), set last clicked element to null (options related)
    componentWillUnmount = () => {
        this.props.onElemTypeChange(null);
        this.detectPopup(this.getElementsView())
    };

    componentDidUpdate = () => {
        this.detectPopup(this.getElementsView())
    };

    setDataForWidget = (newObject, originalObject, type) => {
        if (type !== 'widget') { return; }
        const widgetPosition = JSON.parse(localStorage.getItem('onlineCreatorB2B-widget'));
        const widgetPositionSettings = JSON.parse(localStorage.getItem('onlineCreatorB2B-settings'));

        if(widgetPosition!==null ){
            if(widgetPositionSettings!==null){
            widgetPositionSettings.widgetPosition=widgetPosition
            localStorage.setItem("onlineCreatorB2B-settings", JSON.stringify(widgetPositionSettings));
            }
            newObject.config=JSON.stringify({"widgetPosition": widgetPosition})
            originalObject.config=JSON.stringify({"widgetPosition": widgetPosition})
        }
    }

    detectPopup(elements) {
        let isElementOnPopupVisible = false;
    
        for (const i in elements.props.body) {
            const elementName = elements.props.body[i].id;
            if (elementName.includes("Popup") || elementName.includes("popup") || elementName.includes("widget")) {
                isElementOnPopupVisible = true;
            }
        }

        if (isElementOnPopupVisible === true) {
            if (!this.props.showSwitchButton) {
                this.props.toggleSwitchButton();
            }
        } else {
            if(this.props.showSwitchButton) {
                this.props.toggleSwitchButton();
            } 
        }   
    }

    render = () => (
        <React.Fragment>
            <MainLayoutContainer
                preview={this.props.pagePreview}
                isPreviewOpen={!this.props.isPreviewOn}
                isSideBarOpen={!this.props.isPreviewOn}
                isHeaderOpen={!this.props.isPreviewOn}
                isNavbarOpen={!this.props.isPreviewOn}
                header={this.props.pageHeader}
                navbarContent={this.props.navbar}
                sidebarContent={this.props.sidebar}
                showSwitchButton={this.props.showSwitchButton}
                elements={this.getElementsView()}
                isMobileOn={this.props.isMobileOn}
                handleMobilePreview={this.props.handleMobilePreview}
            />
        </React.Fragment>
    )
}

Page.propTypes = {
    elementTypes: PropTypes.array.isRequired,
    pageType: PropTypes.string.isRequired,
    header: PropTypes.array.isRequired,
    footer: PropTypes.array.isRequired,
    body: PropTypes.array.isRequired,
    bodyListName: PropTypes.string.isRequired,
    handleOptionsOpen: PropTypes.func.isRequired,
    isPreviewOn: PropTypes.bool.isRequired,
    isStyleMenuOpen: PropTypes.bool.isRequired,
    isMobileOn: PropTypes.bool.isRequired,
    handleMobilePreview: PropTypes.func.isRequired,
    onElemTypeChange: PropTypes.func.isRequired,
    currentOpenedNewElements: PropTypes.array.isRequired,
    showNewElementModal: PropTypes.func.isRequired,
    onRecTypeChange: PropTypes.func.isRequired,
    onPromotionalBannerTypeChange: PropTypes.func.isRequired,
    sidebarRef: PropTypes.object.isRequired,
    navbarRef: PropTypes.object.isRequired,
    handleDragStart: PropTypes.func.isRequired,
    showSwitchButton: PropTypes.bool.isRequired,
    toggleSwitchButton: PropTypes.func.isRequired,
    pagePreview: PropTypes.node,
    pageHeader: PropTypes.node,
    navbar: PropTypes.node,
    sidebar: PropTypes.node,
    recTypeCurrent: PropTypes.number,
    promotionalBannerTypeCurrent: PropTypes.number,
};

export default Page;